// maintenanceConfig.ts

export enum MaintenanceModeEnum {
  OFF = "OFF",
  FULL = "FULL",
  REAL_USERS = "REAL-USERS"
}

export type MaintenanceModeType =
  | MaintenanceModeEnum.OFF
  | MaintenanceModeEnum.FULL
  | MaintenanceModeEnum.REAL_USERS;

export type PreConfigType = {
  maintenanceMode: MaintenanceModeType; // "OFF" | "FULL" | "REAL-USERS"
};
let cachedMode: PreConfigType = { maintenanceMode: MaintenanceModeEnum.OFF };
let initialized = false;

export const initPreConfig = async () => {
  if (initialized) return;

  try {
    const res = await fetch("/pre-config.json");
    const data = await res.json();

    if (
      [
        MaintenanceModeEnum.OFF,
        MaintenanceModeEnum.FULL,
        MaintenanceModeEnum.REAL_USERS
      ].includes(data?.mode)
    ) {
      cachedMode = { maintenanceMode: data.mode };
    }
  } catch (e) {
    console.warn("Failed to load pre config. Using default from code.", e);
  }
  initialized = true;
};

// sync getter for cached usage
export const preConfig: PreConfigType = cachedMode;

// dynamic getter (for advanced cases)
export const getPreConfig = (): PreConfigType => cachedMode;
